module.exports = {

    TOTPErrorCodes: [
        '0203001',
        '0203002',
        '0203003',
        '0203004',
        '0203005',
        '0203201',
        '0203202',
        '0203203']

}